import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { MessageText2 } from 'blaze-ui/icons'
import Styles from 'components/CollaborationDrawer/CollaborationDrawer.module.scss'
import { useCollaborationCount } from 'components/DocRightRailV2/UseCollaborationCount'
import { useRootStore } from 'stores/RootStore'
import { CollaborationDrawer } from 'components/CollaborationDrawer/CollaborationDrawer'
import { useProseInstance } from 'providers/ProseInstanceProvider'
import { Counter, CounterSize, CounterVariant } from 'blaze-ui/Counter/Counter'
import { TopBarButton } from 'blaze-components/WriterTopBar/TopBarButton'

export const CollaborationDrawerTrigger = observer(({ size = 24 }: { size?: number }) => {
  const docStore = useDocStore()
  const rootStore = useRootStore()
  const { currentViewRef } = useProseInstance()
  const collaborationCount = useCollaborationCount()

  return (
    <>
      <TopBarButton
        icon={() => <MessageText2 size={size} />}
        label="View Comments"
        onPress={() => {
          rootStore.comments.select(undefined)
          docStore?.collabItemsStore.select(undefined)
          rootStore.drawersStore?.openDrawer(CollaborationDrawer, { view: currentViewRef.current })
        }}
      />

      {collaborationCount > 0 && (
        <div className={Styles.counterWrapper}>
          <Counter variant={CounterVariant.Dark} count={collaborationCount} size={CounterSize.xs} />
        </div>
      )}
    </>
  )
})
